import { makeStyles } from '@mui/styles';
import { NEON_BLUE_LIGHT } from '@returnmates/client-core/src/constants/colors';
var useStyles = makeStyles(function () { return ({
    spinnerWrapper: {
        position: 'absolute',
        top: 0,
        left: 0,
        background: '#FFFFFF',
        zIndex: 10,
        display: 'flex',
        flexDirection: 'column',
        alignItems: 'center',
        justifyContent: 'center',
        width: '100%',
        height: '100%',
    },
    ballContainer: {
        position: 'relative',
        height: 150,
    },
    ball: {
        width: '50px',
        height: '50px',
        backgroundImage: 'url(/assets/images/spinner/swayWilson.png)',
        backgroundSize: 'cover',
        backgroundColor: 'rgba(133, 133, 133, 0.1)',
        borderRadius: '50%',
        position: 'absolute',
        top: '0px',
        left: -25,
        boxShadow: '0px 0px 12px rgba(0,0,0,.1)',
        animationName: '$bounce',
        animationDuration: '0.6s',
        animationDirection: 'alternate',
        animationTimingFunction: 'cubic-bezier(0.95, 0.05, 0.795, 0.035)',
        animationIterationCount: 'infinite',
    },
    shadow: {
        width: '48px',
        height: '8px',
        background: 'radial-gradient(50% 50%, rgb(199, 199, 199), rgba(150,150,150,0.05))',
        position: 'absolute',
        top: 'calc(160px - 1.5 * 8px)',
        left: -25,
        animationName: '$grow',
        animationDuration: '0.6s',
        animationDirection: 'alternate',
        animationTimingFunction: 'cubic-bezier(0.95, 0.05, 0.795, 0.035)',
        animationIterationCount: 'infinite',
    },
    logo: {
        width: '100px',
        height: '55px',
        top: '150px',
        left: '-55px',
        backgroundImage: 'url(/assets/images/spinner/swayLogo.png)',
        backgroundSize: 'cover',
        position: 'absolute',
    },
    spinner: {
        color: NEON_BLUE_LIGHT,
    },
    '@keyframes bounce': {
        from: {
            transform: 'translateY(0) scale(1, 1)',
        },
        to: {
            transform: 'translateY(100px) scale(1.1, .6)',
        },
    },
    '@keyframes grow': {
        from: {
            transform: 'scale(.7, 0.5)',
        },
        to: {
            transform: 'scale(1.2, 0.8)',
        },
    },
}); });
export default useStyles;
//# sourceMappingURL=styles.js.map